var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from "lodash";
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var UIStepController = {
    /*****************************************************************************************************
        * Is using route "api/uistep" and http method "GET" to call the back-end.
    
        * @returns {UIStepsDownloadDto[]}
    ******************************************************************************************************/
    GetAll: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/uistep", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/uistep/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {UIStepsDownloadDto}
    ******************************************************************************************************/
    GetById: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/uistep/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/uistep/group/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {UIStepsDownloadDto[]}
    ******************************************************************************************************/
    GetForGroupByGroupId: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/uistep/group/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/uistep/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {UIStepsUploadDto} data
        * @param {{[key: string]: File}} stepMedia
        * @returns {UIStepsDownloadDto}
    ******************************************************************************************************/
    PatchUISteps: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        _.forEach(data.stepMedia, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/uistep/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/uistep/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @param {UIStepsUploadDto} data
        * @param {{[key: string]: File}} stepMedia
        * @returns {UIStepsDownloadDto}
    ******************************************************************************************************/
    PostUISteps: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        _.forEach(data.stepMedia, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/uistep/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/uistep/for/group" and http method "GET" to call the back-end.
    
        * @returns {UIStepsDownloadDto}
    ******************************************************************************************************/
    GetForGroup: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/uistep/for/group", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=UIStepController.js.map